module.exports = __webpack_public_path__ + "img/apple-music.9347f097.svg";